import types from './action-types';
import moduleName from './module';

const service = abp.services.api.chainageService;

const apiDataTransformer = (data) => {
    data.forEach(excavation => {
        excavation.chainages = excavation.chainages.map(item => ({ x: new Date(item.dateTime), y: item.chainageValue }))
    });

    return data;
}

export const refreshData = () => {
    return (dispatch, getState) => {
        var excavationIds = getState()[moduleName].excavationIds;

        loadDataInternal(excavationIds, undefined, dispatch);
    }
};

export const loadData = (excavationIds, profileId) => {
    return (dispatch) => {
        loadDataInternal(excavationIds, profileId, dispatch);
    }
};

const loadDataInternal = (excavationIds, profileId, dispatch) => {
    dispatch({ type: types.LOADING, excavationIds });

    service.getAll(excavationIds, profileId)
        .done(result => {
            const coordinates = apiDataTransformer(result);

            dispatch({
                type: types.DATA_LOADED,
                coordinates: coordinates
            });
        });
};



// WEBPACK FOOTER //
// ./App/components/modules/chainageChart/actions.js